import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLogout = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M2.127 20a2.053 2.053 0 0 1-1.51-.618A2.053 2.053 0 0 1 0 17.873V2.127c0-.595.206-1.098.618-1.51A2.053 2.053 0 0 1 2.127 0h7.884v1.765H2.127a.345.345 0 0 0-.25.113.345.345 0 0 0-.112.249v15.746c0 .09.037.174.113.25a.346.346 0 0 0 .249.112h7.884V20H2.127Zm12.85-4.977-1.221-1.277 2.864-2.864H6.584V9.118H16.62l-2.864-2.864 1.221-1.277L20 10l-5.023 5.023Z" })
});
export { SvgLogout as ReactComponent };
